var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicIndoorpark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b{fill:#c8d1ec;}.c{fill:none;stroke:#c8d1ec;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.2.18A1.886,1.886,0,0,1,2.805-.345,1.926,1.926,0,0,1,2.28-1.77V-19.32a1.793,1.793,0,0,1,.495-1.35,1.878,1.878,0,0,1,1.365-.48h7.38a7.632,7.632,0,0,1,5.28,1.7A6.057,6.057,0,0,1,18.69-14.7,6.1,6.1,0,0,1,16.8-9.93a7.589,7.589,0,0,1-5.28,1.71H6.15v6.45A1.926,1.926,0,0,1,5.625-.345,1.926,1.926,0,0,1,4.2.18Zm6.84-11.37q3.99,0,3.99-3.48t-3.99-3.48H6.15v6.96Z",
    transform: "translate(27 50)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6381,9219.3l7.276-6.11,7.277,6.11",
    transform: "translate(-6351.5 -9197.366)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIndoorpark);
export default __webpack_public_path__ + "static/media/public_indoorpark.1096abc749b55291af0f6675bd456787.svg";
export { ForwardRef as ReactComponent };